import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { RecoilRoot } from "recoil";
import "./index.css";
import r2wc from "@r2wc/react-to-web-component";
import cssText from "bundle-text:./index.css";

let style = document.createElement('style');
style.textContent = cssText;
document.head.appendChild(style);

const Component = (config: { theme: string; "api-key": string }) => (
  <RecoilRoot>
    <ChakraProvider>
      <App {...config} />
    </ChakraProvider>
  </RecoilRoot>
);

const WebApp = r2wc(Component, {
  props: { theme: "string", "api-key": "string" },
});

customElements.define("rss-feed", WebApp);
